module.exports = __webpack_public_path__ + "static/media/icone-play.9542bb23.svg";